import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    shownEvent: String,
    context: String,
    planRecommended: String,
  };

  connect() {
    if (this.hasShownEventValue) {
      this._send(this.shownEventValue, {
        context: this.contextValue,
        plan_recommended: this.planRecommendedValue,
      });
    }
  }

  track({ params: { event: eventName, plan } }) {
    const payload = plan ? { plan } : {};
    this._send(eventName, payload);
  }

  _send(name, payload = {}) {
    if (typeof window.userengage !== 'function') return;
    window.userengage(name, { ...payload, timestamp: Date.now() });
  }
}
